import { TextField, useFormContext } from '@calendly/form'
import { I18n } from '@calendly/i18n'
import { BodyText, TitleText } from '@calendly/ui/components/typography'
import { useSelector } from 'react-redux'

import { CUSTOM_SMS_LEGAL_DISCLAIMER } from 'constants/billing_features'
import { isAvailableFeatureSelector } from 'features/billing'
import { SMSLegalDisclaimerPaywall } from 'shared/paywalls/sms_legal_disclaimer'

import { StyledFormRow } from '../styles'

const HeadingComponent = (props) => <TitleText {...props} level={2} size="medium" />

export const SmsLegalDisclaimerComponent = () => {
  const hasSmsLegalDisclaimerAccess = useSelector(
    (state) => isAvailableFeatureSelector(state, { featureKey: CUSTOM_SMS_LEGAL_DISCLAIMER })
  )
  const { errors } = useFormContext()

  if (!hasSmsLegalDisclaimerAccess) {
    return (
      <SMSLegalDisclaimerPaywall
        wrapperComponent={StyledFormRow}
        headingTextComponent={HeadingComponent}
      />
    )
  }

  return (
    <StyledFormRow>
      <TitleText level={2} size="medium">
        {I18n.t('publisher.organization.branding.sms_legal_disclaimer.label')}
      </TitleText>
      <BodyText>{I18n.t('publisher.organization.branding.sms_legal_disclaimer.description')}</BodyText>
      <TextField
        name="legalDisclaimer"
        aria-label={I18n.t('publisher.organization.branding.sms_legal_disclaimer.label')}
        type="textarea"
        rows={5}
        error={errors.legalDisclaimer}
      />
    </StyledFormRow>
  )
}
